import React from 'react';
import styled from 'styled-components';
import COLORS from '../../common/styles/color-pallete';

const DividerStyle = styled.div<{
  $paddingHorizontal: string;
  $backgroundColor: string;
  color: string;
  height: string;
  $marginVertical: string;
}>`
  width: 100%;
  background-color: ${(props) => props.$backgroundColor};
  position: relative;
  height: ${(props) => props.height};
  box-sizing: border-box;
  margin: ${(props) => props.$marginVertical} 0px;
  display: block;
  div {
    height: ${(props) => props.height};
    position: absolute;
    left: ${(props) => props.$paddingHorizontal};
    right: ${(props) => props.$paddingHorizontal};
    background-color: ${(props) => props.color};
  }
`;

type IDivider = {
  className?: string;
  $paddingHorizontal?: string;
  $backgroundColor?: string;
  color?: string;
  height: string;
  $marginVertical?: string;
};

const Divider: React.FC<IDivider> = ({
  className,
  $paddingHorizontal = '0px',
  $backgroundColor = '#fff',
  color = `${COLORS.borderGrey}`,
  height,
  $marginVertical = '0px'
}) => {
  return (
    <DividerStyle
      className={className}
      $paddingHorizontal={$paddingHorizontal}
      $backgroundColor={$backgroundColor}
      $marginVertical={$marginVertical}
      color={color}
      height={height}
    >
      <div></div>
    </DividerStyle>
  );
};

export default Divider;
